import { __decorate } from "tslib";
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import HelixElement from '../../shared/types/helix-element.js';
import { localized } from '@lit/localize';
import { componentStyles } from '../../shared/styles/component.styles.js';
import { carouselItemStyles } from './carousel-item.styles.js';
let HlxCarouselItem = class HlxCarouselItem extends HelixElement {
    constructor() {
        super(...arguments);
        this.styleMutationObserver = new MutationObserver(() => this.requestUpdate());
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'group');
        this.styleMutationObserver.observe(this, { attributes: true, attributeFilter: ['style'] });
    }
    disconnectedCallback() {
        this.styleMutationObserver.disconnect();
        super.disconnectedCallback();
    }
    render() {
        return html `
            <div class="hlx-carousel-item" style=${this.style.cssText}>
                <slot></slot>
            </div>
        `;
    }
};
HlxCarouselItem.styles = [componentStyles, carouselItemStyles];
HlxCarouselItem = __decorate([
    customElement('hlx-carousel-item'),
    localized()
], HlxCarouselItem);
export { HlxCarouselItem };
//# sourceMappingURL=carousel-item.js.map